import { render, staticRenderFns } from "./Tender.vue?vue&type=template&id=17901c53&"
import script from "./Tender.vue?vue&type=script&lang=js&"
export * from "./Tender.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports